export default __webpack_public_path__ + "static/media/Insight_data_tableau_récap_02.1ace93c8.svg";